import { BRAND } from '../lib/brand'
import { MARK_PATH } from '../lib/brandMark'
import { cn } from '../lib/utils'

const MARK = { sm: 'size-6', md: 'size-7', lg: 'size-8' } as const
const WORD = { sm: 'text-sm', md: 'text-base', lg: 'text-xl' } as const

export function LogoMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 512 512"
      className={cn('shrink-0', className)}
      fill="var(--brand-mark, #ff6715)"
      aria-hidden="true"
    >
      <path d={MARK_PATH} />
    </svg>
  )
}

// Logo lockup: mark + optional wordmark + optional platform badge. Wordmark and
// label come from BRAND, so a re-brand is a one-file change.
export default function Logo({
  size = 'md',
  showWordmark = true,
  showBadge = false,
  className,
}: {
  size?: keyof typeof MARK
  showWordmark?: boolean
  showBadge?: boolean
  className?: string
}) {
  return (
    <div className={cn('flex items-center gap-2', className)}>
      <LogoMark className={MARK[size]} />
      {showWordmark && (
        <span className="flex items-baseline gap-1.5 leading-none">
          <span className={cn('font-semibold tracking-tight', WORD[size])}>{BRAND.name}</span>
          {showBadge && (
            <span className="rounded bg-secondary px-1.5 py-px text-caption font-normal text-muted-foreground">
              {BRAND.platformLabel}
            </span>
          )}
        </span>
      )}
    </div>
  )
}
